



<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>





		<div class="headmenu">
					<div class="header-links-container ">
						<ul class="topnav navRight topnav">
							<!-- Support panel trigger
							<li class="hidden-sm-down" >
								<label for="support_p" class="spanel-label">
									<span style="color:#9b7544;">SUPPORT</span>
		                    		<i class="material-icons" style="	color: #9b7544;" >info_outline</i>
								</label>
							</li>
							/ Support panel trigger -->

							<!-- Shop Cart -->
								<li class="drop">
									<a  class="kl-cart-button" title="View your shopping cart">
										<i class="material-icons" style="font-size: 30px; color: #9b7544;">
											local_grocery_store </i>
										<span class="hidden-sm-down" style="font-size: 20px;color:#9b7544;">
											<strong>{{totalitems}}</strong></span>
									</a>
									<div class="pPanel">
										<div class="inner cart-container">
											<div class="widget_shopping_cart_content" *ngIf="data2 && data2.length>0; else empty">
												<ul class="cart_list product_list_widget "
												  style="max-height:350px; overflow-y:scroll;">
													<li *ngFor="let item of data2">
													<a  class="product-title">
												<img src="https://passport.petcart.in/images/prodimgs{{imgpath['id'+item.sku]}}" style="height:90px" />
												{{ item.product_name }}
													</a>
													<span class="quantity">{{ item.quantity }} ×
														<span class="amount">Rs. {{ item.mrp }} </span></span></li>
												</ul>
												<!-- end product list -->
												<p class="total">
													<strong>Subtotal:</strong><span class="amount">Rs. {{subtotal}}</span>
												</p>
												<p class="buttons">
													<a (click)="goToCart()" class="button wc-forward" style="background-color:#dbd3be; color:#9b7544">View Cart</a>
													<a (click)="finalCheck()" class="button checkout wc-forward" style="    border: 2px solid #dbd3be; color:#9b7544">Checkout</a>
												</p>
											</div>
										</div>
									</div>
								</li>
							<!--/ Shop Cart -->




							<!-- Profile -->
								<li class="drop" *ngIf="userStatus ==1; else login">
									<a class="kl-cart-button" title="View your shopping cart">
											<img src="https://passport.petcart.in/images/userimgs/{{userimg}}" style="height:40px" >
										<span class="hidden-sm-down" style="color:#9b7544;">Hi {{username}}</span>
									</a>
									<div class="pPanel">
										<div class="inner cart-container" style="z-index:4000;">
											<div class="widget_shopping_cart_content" *ngIf="userStatus==1 && userrole !=3">
												<ul class="cart_list product_list_widget ">
													<li routerLink="/manageprofile/order">Manage Orders</li>
													<li routerLink="/manageprofile/manageyourpet">Manage Pets</li>
													<li routerLink="/manageprofile/appointment">Manage Appointments</li>
												</ul>
												<p class="total" style="cursor: pointer" *ngIf="lastorder.length>0"
														(click)="goForReorder(lastorder[0].orderno)">
													<strong >Last Transaction:</strong> {{lastorder[0].orderno}} - Reorder
												</p>

												<p class="buttons">
													<a  routerLink="/manageprofile" class="button wc-forward" style="background-color:#dbd3be; color:#9b7544">My Profile</a>
													<a (click)="logout()" style="    border: 2px solid #dbd3be; color:#9b7544"
													 class="button checkout wc-forward">Logout</a>
												</p>


											</div>
											<div class="widget_shopping_cart_content" *ngIf="userStatus==1 && userrole ==3">
													<button class="btn btn-secondary btn-block">
											<a  routerLink="/doctor/home"
											style="color: #fff">Go to Dashboard</a>
													</button>
												</div>
											<div class="widget_shopping_cart_content" *ngIf="userStatus==0">
													<ul class="cart_list product_list_widget ">
															<li  (click)="login()">
														<mat-icon>power_settings_new</mat-icon>Sign In</li>
														</ul>
											</div>
										</div>
									</div>
								</li>
							<!--/ Profile -->




						</ul>

					</div>










							<a href="index.html" title="">
								<img *ngIf="pulsemenuflag == 1" src="assets/images/logopulse.png" class="logo-img" alt="petcart" title="petcart logo" />
								<img *ngIf="menuflag == 1" src="assets/images/logostore.png" class="logo-img" alt="petcart" title="petcart logo" />
								<img *ngIf="nestmenuflag == 1" src="assets/images/logonest.png" class="logo-img" alt="petcart" title="petcart logo" />

								<img *ngIf="((pulsemenuflag != 1) && (menuflag != 1) && (nestmenuflag != 1))" src="assets/images/logo.png" class="logo-img" alt="petcart" title="petcart logo" />

							</a>


							<!--menutest-->
									 <div class="hidden-sm-down" style="right:0px; position:absolute; z-index: 1000; width:310px;    top: 20px; left:210px;">
									 <div class="wsmenucontainer clearfix">
											 <div id="overlapblackbg"></div>
											 <div class="wsmobileheader clearfix">

												 <a id="wsnavtoggle" class="animated-arrow"><span></span></a>

												</div>

											 <div class="headerfull">


												 <div class="dropdown" style="  position: absolute; margin-right:100px;">
													 <button class="dropbtn">
														 <a style="text-decoration:none"  routerLink="/store/home" class="navtext">
															 <span class="hovcolor">   <img *ngIf="menuflag == 1" src="assets/images/storep22.png" class="imgp" >
																 <img *ngIf="menuflag != 1" src="assets/images/storep.png" class="imgp" ><!--  <i class="fas fa-cart-plus"></i> -->
															 <br>  <span style="font-size: 18px; margin-right: 10px;" class="hidden-sm-down">Store</span></span>
														 </a>
													 </button>



											 </div>


											<div class="dropdown" style="  position: absolute; margin: 0 0 0 100px;">
												 <button class="dropbtn">
													 <a style="text-decoration:none" routerLink="/pulse/home" class="navtext">
													<span class="hovcolor"><img *ngIf="pulsemenuflag == 1" src="assets/images/pulsep22.png" class="imgp" >
														<img *ngIf="pulsemenuflag != 1" src="assets/images/pulsep.png" class="imgp" >
														<!--<i class="fas fa-user-md"></i> -->
													 <br>    <span style="font-size: 18px; margin-right: 10px;" class="hidden-sm-down">Pulse</span></span>
													 </a>
												 </button>


												 <div class="dropdown-content dropmenu" style="display:none">

															 <ul style="list-style:none; padding-left: 0px !important;">
																 <li class="limenu"><a class="lilink" routerLink="/pulse/doctor">Appointment with a Vet</a></li>
																 <li class="limenu"><a class="lilink" routerLink="/pulse/onlinedoctors">Chat with a Vet</a></li>
																 <li class="limenu"><a class="lilink" routerLink="/pulse/doctor">Set Reminders</a></li>
																 <li class="limenu"><a class="lilink" routerLink="/manageprofile/manageyourpet">Scan Records</a> </li>
																 <li class="limenu"><a class="lilink" routerLink="/pulse/doctor">Know Yourself</a></li>
																 <li class="limenu"><a class="lilink" routerLink="/vets">For Vets</a></li>
															 </ul>

												 </div>
											 </div>


											 <div class="dropdown" style="  position: absolute; margin: 0 0 0 200px;">
												 <button class="dropbtn">
													 <a style="text-decoration:none"  routerLink="/nest/home" class="navtext">
													 <span class="hovcolor"><img img *ngIf="nestmenuflag != 1" src="assets/images/nestp.png" class="imgp" ><!--<i class="fas fa-home"></i> -->
														<img *ngIf="nestmenuflag == 1" src="assets/images/nestp22.png" class="imgp" >
													 <br>    <span style="font-size: 18px; margin-right: 10px;" class="hidden-sm-down">Nest</span></span>
													 </a>
												 </button>



											 </div>









													 </div>

														 </div>
									 </div>

















									 <!--menutest-->







			</div>
			<ng-template #login>
				<li style="    width: 100px;">
				<div class="wstheading clearfix" id="loginbtn2" style="cursor:pointer; border:none;" routerLink="/signin">
						<mat-icon style="    vertical-align: middle;">power_settings_new</mat-icon>Sign In</div>
					</li>
					</ng-template>

				<ng-template #empty>
					<li>
					<h4 style="font-size:16px;">
						You have no items in your shopping cart.
					</h4>
						</li>
					</ng-template>
